import React, { useCallback, useState, ReactNode } from 'react';
import Modal from '@ui-library/modal/skeleton';

const useModalView = (comp: ReactNode) => {
  const [showModal, setShowModal] = useState(false);
  const a = useCallback(
    (b: boolean) => {
      setShowModal(b);
    },
    [setShowModal],
  );

  let modal = null;
  if (showModal) {
    modal = (
      <Modal modalClosed={() => setShowModal(false)} show>
        {comp}
      </Modal>
    );
  }

  return [modal, a] as const;
};

export default useModalView;
